import * as React from 'react';

class ErrorBoundary extends React.Component<{ children: React.ReactNode, fallback: React.ReactNode }> {
  public state: { hasError: boolean, error: Error | null };

  constructor(props: { children: React.ReactNode, fallback: React.ReactNode }) {
    super(props);

    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return {
      hasError: true,
      error,
    };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error(error, info);
  }

  render() {
    if (this.state.hasError) {
      return <>
        {this.props.fallback}
        <br />
        {this.state.error?.message}
        <br />
        {this.state.error?.stack}
      </>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
